export class Product {
    id: number;
    sku: string;
    name:string;
    description: string;
    imageUrl: string;
    isSerializable: boolean;
    warrantyDurationMonths : number;
  }